export default "<div #map style=\"width: 350px; height: 350px\" ></div>\r\n<div class=\"float-right\" style=\"color:lightgray\">{{lat}} / {{lng}}</div>\r\n"